import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDailyWarmup = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M8 3.5V6.5M16 6.5V3.5",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 13C21 6.77778 19 5 12.0005 5C5.00092 5 3 6.77778 3 13C3 19.2222 5.07784 21 12.0005 21L13.0004 21M21 13C21 15.6667 15.6667 21 13.0004 21M21 13C17.4444 13.8889 15.6666 13 14.3333 14.3333C13 15.6666 13.8889 17.4444 13.0004 21",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgDailyWarmup);
export { ForwardRef as ReactComponent };
